<div *ngIf="!isServer"
    class="product-gallery__featured"
    redZoomClass="product-red-zoom product-red-zoom--layout--{{ productLayout }}"
    [redZoom]="currentItem?.image"
    [redZoomThumb]="currentItem?.image"
    [redZoomLazy]="true"
    [redZoomBehavior]="zoomBehave"
>
    <div class="product-gallery__featured-inset extra-fr-size">
        <button *ngIf="productLayout !== 'quickview'" class="product-gallery__zoom" (click)="openPhotoSwipe(currentItem)" [attr.title]="'zoom' | t:'Zoom'">
            <app-icon name="zoom-in-24" size="24"></app-icon>
        </button>
        <owl-carousel-o [options]="carouselOptions" (changed)="featuredCarouselTranslated($event)" appOwlPreventClick appTouchSlop #featuredCarousel> 
            <ng-template *ngFor="let item of items" carouselSlide [id]="item.id">
                <div class="product-image product-image--location--gallery">
                    <a
                        *ngIf="item.id !== 'vid'"
                        appClick
                        class="product-image__body"
                        rel="noopener noreferrer"
                        target="_blank"
                        [href]="getWebpImageUrl(item.image)"
                        (click)="onFeaturedImageClick($event, item);"> 
                        <img class="product-image__img" [src]="getWebpImageUrl(item.image)" [alt]="productName" #imageElement>
                    </a>
                    <div *ngIf="item.id === 'vid'" class="product-image__body video-wrapper" [class.playing]="!showPlayButton"> 
                        <video controls [loop]="true" [muted]="true" [muted]="true" preload="metadata" loading="lazy" oncanplay="this.play()"
                            #videoPlayer [poster]="item.image" class="product-image__img video" 
                            (play)="onPlay()" (pause)="onPause()">
                            <source [src]="item.video"  type="video/mp4">
                            {{ 'video-not-supported' | t:'Your browser does not support the video tag.' }}
                        </video>
                        <div class="play-button" *ngIf="showPlayButton"></div>
                    </div>
                </div>
            </ng-template>
        </owl-carousel-o>
    </div>
</div>  

<div class="product-gallery__featured-inset" *ngIf="isServer"> 
    <div class="product-image product-image--location--gallery">
        <a
            appClick
            class="product-image__body"
            rel="noopener noreferrer"
            target="_blank"
            [href]="getWebpImageUrl(currentItem?.image)"> 
            <img fetchpriority="high" class="product-image__img" [src]="getWebpImageUrl(currentItem.image)" [alt]="productName" #imageElement>
        </a>
    </div>
</div>  

<div class="product-gallery__carousel">
    <owl-carousel-o
        appOwlPreventClick appTouchSlop
        [options]="thumbnailsCarouselOptions"
        [appFakeSlides]="items.length"
        #fakeSlides="appFakeSlides"
        #thumbnailsCarousel>
        <!--suppress AngularUndefinedBinding -->
        <ng-template *ngFor="let item of items" carouselSlide [id]="item.id" >
            <div appClick
                class="product-image product-gallery__carousel-item"
                [class.product-gallery__carousel-item--active]="item === currentItem"
                (click)="onThumbnailImageClick(item)">
                <div class="product-image__body">
                    <img loading="lazy" class="product-image__img" [src]="getWebpImageUrl(item.image)" [alt]="productName" #imageElement> 
                    <div class="play-button-sm" *ngIf="item.id == 'vid'"></div>
                </div>
            </div>
        </ng-template>
        <!--suppress AngularUndefinedBinding -->
        <ng-template *ngFor="let i of fakeSlides.slides" carouselSlide [id]="'fake-slide-'+i"></ng-template>
    </owl-carousel-o>
</div>
